module.exports = "/assets/images/info-in-circle_4a22d3.svg";